module.exports = __webpack_public_path__ + "img/block-l-2.2acc243b.jpg";